import { TRawPropertyActionValidator } from "@propely/propely-typings";
import { getDoc, getFirestore, doc } from "firebase/firestore";
import { useQuery, useQueries } from "react-query";

export const usePropertyActionValidatorKey = (propertyID: string) => ["property-action-validator", { propertyID }];

const fetchPropertyActionValidator = async (propertyID: string) => {
  const actionValidator = await getDoc(doc(getFirestore(), "properties", propertyID, "settings", "actionValidator"));
  return TRawPropertyActionValidator.parse({
    id: actionValidator.id,
    ...actionValidator.data(),
  });
};

export const usePropertyActionValidator = (propertyID: string) => {
  const $actionValidator = useQuery(usePropertyActionValidatorKey(propertyID), () => fetchPropertyActionValidator(propertyID));
  return {
    $actionValidator,
    actionValidator: $actionValidator.data,
  };
};

export const usePropertiesActionValidator = (propertyIDs: string[]) => {
  const $actionValidators = useQueries(
    propertyIDs.map((propertyID) => ({
      queryKey: usePropertyActionValidatorKey(propertyID),
      queryFn: () => fetchPropertyActionValidator(propertyID).then((data) => ({ propertyID, data })),
    }))
  );

  return {
    $actionValidators,
    actionValidators: $actionValidators.map(($property) => $property.data),
  };
};

